<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BTabs
      v-model="currentTabIndex"
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      class="mt-3"
    >
      <BTab>
        <template #title>
          <i :class="iconState('fa-file-circle-info', currentTabIndex === 0)" /> Pendings
        </template>
        <ClosingPending
          ref="scPending"
          :tab-index="currentTabIndex"
          @show="showClosing"
        />
      </BTab>

      <BTab>
        <template #title>
          <i :class="iconState('fa-clock-rotate-left', currentTabIndex === 1)" /> Closed
        </template>
        <ClosingHistory
          ref="scHistory"
          :tab-index="currentTabIndex"
          @show="showClosing"
        />
      </BTab>
    </BTabs>

    <BModal
      id="modalClosing"
      size="xl"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
      >
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-list-tree mr-1" />
              <b class="is-tab-active">Products</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">

            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>
                <BCol
                  cols="12"
                  md="2"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transaction Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transaction_number"
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="2"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transfer Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transfer_number"
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Deliver To"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.destination_name"
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Delivery From"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.origin_name"
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="2"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Group"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.group_name"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Remarks"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.remarks || 'no remarks'"
                    />
                  </BFormGroup>
                </BCol>
              </BRow>
            </BCol>

            <BCol
              cols="12"
              class="px-0 px-md-1"
            >
              <BTable
                ref="tableProducts"
                small
                hover
                striped
                bordered
                responsive
                show-empty
                class="mb-0"
                :items="stockRequest.details"
                :busy="tableProducts.busy"
                :filter="tableProducts.filter"
                :fields="tableProducts.fields"
                :stacked="tableProducts.stacked"
                :filter-included-fields="tableProducts.filterOn"
              >
                <template #cell(index)="{ index }">
                  <div
                    class="text-md-nowrap"
                    v-text="tableRowNumber(tableProducts, index)"
                  />
                </template>

                <template #cell()="{ value }">
                  <div
                    class="text-md-nowrap d-flex align-items-center min-h-35px px-1"
                    v-text="value"
                  />
                </template>

                <template #cell(product_name)="{ value }">
                  <div class="text-md-nowrap d-flex align-items-center min-h-35px px-1">
                    <strong
                      class="font-weight-bolder"
                      v-text="value"
                    />
                  </div>
                </template>

                <template #cell(posting_quantity)="{ value }">
                  <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                    <strong
                      class="font-weight-bolder"
                      v-text="value"
                    />
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center py-5">
                    <BIcon
                      icon="stopwatch"
                      font-scale="5"
                      animation="cylon"
                    />
                    <p class="h3 py-2">
                      <strong>Loading . . .</strong>
                    </p>
                  </div>
                </template>

              </BTable>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-file-lines mr-1" />
              <b class="is-tab-active">Delivery Details</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>
                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label-for="fCustomerDirect"
                    class="mb-1"
                  >
                    <BFormCheckbox
                      id="fCustomerDirect"
                      v-model="stockRequest.delivery_details.customer_direct"
                      switch
                      value="1"
                      name="customer_direct"
                      unchecked-value="0"
                      disabled
                    >
                      <strong>Direct Deliver to Customer?</strong>
                    </BFormCheckbox>
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Mobile Number"
                    label-for="fvCustomerMobile"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvCustomerMobile"
                      v-model="stockRequest.delivery_details.mobile_number"
                      type="text"
                      placeholder="no customer mobile"
                      disabled
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Name"
                    label-for="fvCustomerName"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvCustomerName"
                      v-model="stockRequest.delivery_details.customer"
                      type="text"
                      placeholder="no customer name"
                      disabled
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Address"
                    label-for="fvCustomerAddress"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BTextarea
                      id="fvCustomerAddress"
                      v-model="stockRequest.delivery_details.address"
                      rows="4"
                      max-rows="6"
                      maxlength="50"
                      placeholder="no customer address"
                      disabled
                    />
                  </BFormGroup>
                </BCol>
              </BRow>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-calendar-range mr-1" />
              <b class="is-tab-active">Delivery Schedule</b>
            </div>
          </template>

          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Trip Type"
                    label-for="fvScheduleTripType"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleTripType"
                      v-model="stockRequest.schedule_details.trip_type"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Date"
                    label-for="fvScheduleDate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleDate"
                      v-model="stockRequest.schedule_details.date"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                >
                  <BRow>

                    <BCol
                      cols="12"
                      md="6"
                      class="px-1 px-md-2"
                    >
                      <BFormGroup
                        label="Driver"
                        label-for="fvScheduleDriver"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fvScheduleDriver"
                          v-model="stockRequest.schedule_details.driver_name"
                          type="text"
                          maxlength="50"
                          placeholder="no driver"
                          disabled
                        />
                      </BFormGroup>
                    </BCol>

                    <BCol
                      cols="12"
                      md="6"
                      class="px-1 px-md-2"
                    >
                      <BFormGroup
                        label="Mobile Number"
                        label-for="fvScheduleMobile"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fvScheduleMobile"
                          v-model="stockRequest.schedule_details.mobile_number"
                          type="text"
                          maxlength="50"
                          placeholder="no mobile number"
                          disabled
                        />
                      </BFormGroup>
                    </BCol>
                  </BRow>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Helper"
                    label-for="fvScheduleHelper"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleHelper"
                      v-model="stockRequest.schedule_details.helper"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                >
                  <BRow>

                    <BCol
                      cols="12"
                      md="6"
                      class="px-1 px-md-2"
                    >
                      <BFormGroup
                        label="Vehicle Plate"
                        label-for="fvScheduleVehiclePlate"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fvScheduleVehiclePlate"
                          v-model="stockRequest.schedule_details.vehicle_plate"
                          type="text"
                          maxlength="25"
                          placeholder="no vehicle plate"
                          disabled
                        />
                      </BFormGroup>
                    </BCol>

                    <BCol
                      cols="12"
                      md="6"
                      class="px-1 px-md-2"
                    >
                      <BFormGroup
                        label="Vehicle Name"
                        label-for="fvScheduleVehicleName"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fvScheduleVehicleName"
                          v-model="stockRequest.schedule_details.vehicle_name"
                          type="text"
                          maxlength="50"
                          placeholder="no helper"
                          disabled
                        />
                      </BFormGroup>
                    </BCol>

                  </BRow>
                </BCol>

              </BRow>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2 py-4">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-timeline-arrow mr-1" />
              <b class="is-tab-active ml-1">Tracking</b>
            </div>
          </template>

          <BContainer>
            <Timeline
              :stock-request="stockRequest"
            >
              <template #approvals="request">
                <Signatory
                  :stock-request="request"
                  :approver="requesterSignatory"
                />
                <Signatory
                  v-for="(approver, key) in request.approvals"
                  :key="key"
                  :stock-request="request"
                  :approver="approver"
                />
              </template>
            </Timeline>
          </BContainer>
        </BTab>
      </BTabs>
      <template #modal-footer="{ cancel }">
        <div class="flex-grow-1 d-flex justify-content-between mb-0 pb-0 gap-2">
          <div />
          <div class="d-flex gap-2">
            <BButton
              v-if="state.closing"
              variant="primary"
              size="sm"
              tabindex="-1"
              :disabled="state.busy"
              @click.prevent="$event => validateClosing($event)"
            >
              Mark as Closed
            </BButton>
            <BButton
              :disabled="state.busy"
              size="sm"
              variant="outline-dark"
              tabindex="-1"
              @click.prevent="$event => {
                $event.target.blur()
                cancel()
              }"
            >
              Close <span class="d-none d-md-inline-block">Window</span>
            </BButton>
          </div>
        </div>
      </template>
    </BModal>

  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import ClosingPending from '@/views/lo/closing/Pending.vue'
import ClosingHistory from '@/views/lo/closing/History.vue'

import Timeline from '@/components/custom/timeline/Base.vue'
import Signatory from '@/components/custom/timeline/Signatory.vue'

export default {
  name: 'VLogisticsOfficerClosing',

  middleware: ['auth', 'lo'],

  metaInfo: () => ({
    title: 'Closing'
  }),

  components: {
    ClosingPending,
    ClosingHistory,
    Timeline,
    Signatory
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  data () {
    return {
      currentTabIndex: this.getCurrentTabIndexByURL(),
      state: {
        busy: false,
        closing: false
      },
      stockRequest: {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          destination: '',
          destination_name: '',
          destination_code: '',
          origin: '',
          origin_name: '',
          origin_code: '',
          group: '',
          group_name: '',
          group_code: ''
        },
        delivery_details: {
          customer_direct: 0,
          customer: '',
          address: '',
          mobile_number: ''
        },
        schedule_details: {
          date: '',
          trip_type: '',
          vehicle: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver: '',
          driver_name: '',
          mobile_number: '',
          helper: ''
        },
        details: [],
        approvals: [],
        remarks: ''
      },
      requesterSignatory: {
        stage: 0,
        approver_label: 'Retail Officer - Origin',
        approver_action: 'Purchase Order',
        approver_name: '',
        last_seen: '',
        status: 'Requested',
        status_at: '',
        remarks: ''
      },
      tableProducts: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 1, key: 'product_name', class: 'min-w-200px' },
          { mobile: 2, key: 'posting_quantity', label: 'Quantity', class: ['text-center', { 'col-2': !this.isMobile() }] }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {

    getCurrentTabIndexByURL () {
      switch (this.$route.params.closer) {
        case 'histories' : {
          return 1
        }
        default: {
          return 0
        }
      }
    },

    showClosing (stockRequest, useClosing) {
      this.state.closing = useClosing

      const { id, approvable } = stockRequest
      const { delivery_details, schedule_details } = approvable

      this.stockRequest = Object.assign(this.stockRequest, {
        id: id,
        stage: approvable.stage,
        references: {
          document_number: approvable.document_number,
          transfer_number: approvable.transfer_number,
          sap_doc_entry: approvable.sap_doc_entry,
          transaction_number: approvable.transaction_number
        },
        headers: {
          destination: approvable.destination_id,
          destination_name: approvable.destination_name,
          destination_code: approvable.destination_code,
          origin: approvable.origin_id,
          origin_code: approvable.origin_code,
          origin_name: approvable.origin_name,
          group: approvable.group_id,
          group_code: approvable.group_code,
          group_name: approvable.group_name
        },
        delivery_details: {
          customer_direct: Number(approvable.customer_direct),
          customer: delivery_details.customer,
          mobile_number: delivery_details.mobile_number,
          address: delivery_details.address
        },
        schedule_details: {
          date: this.dateShortFormatter(schedule_details?.date || ''),
          trip_type: schedule_details?.trip_type || '',
          vehicle: schedule_details?.vehicle || '',
          vehicle_plate: schedule_details?.vehicle_plate || '',
          vehicle_name: schedule_details?.vehicle_name || '',
          driver: schedule_details?.driver || '',
          driver_name: schedule_details?.driver_name || '',
          mobile_number: schedule_details?.mobile_number || '',
          helper: schedule_details?.helper || ''
        },
        details: approvable.transfer_details,
        approvals: approvable.approvals,
        remarks: approvable.remarks,
        created_at: approvable.created_at
      })

      this.requesterSignatory = Object.assign(this.requesterSignatory, {
        approver_name: approvable.destination_name,
        status_at: approvable.created_at
      })
      this.$bvModal.show('modalClosing')
    },

    validateClosing ({ target }) {
      this.swalConfirmWithRemarks({
        html: 'Mark Deliveries as Closed?',
        preConfirm: remarks => {
          return this.$refs.scPending.update({
            id: this.stockRequest.id,
            selected: [
              {
                id: this.stockRequest.id,
                remarks: remarks
              }
            ],
            status: 'Closed'
          })
        },
        confirmButtonText: target.innerText
      })
    }
  }
}
</script>
